export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8613.c25c094f.jpg";